<template>
  <div class="package-item">
    <div class="package d-flex align-items-center flex-wrap">
      <Select :options="packageOptions" :value="action.package" @changeValue="store.commit(`${this.storeId}.package`, $event)" placeholder="Package" />
      <component :is="finalActionPackage" :config="config" @changeValue="changeFinalActionPackage" />
      <component :is="finalActionValue" :config="config" @changeValue="changeFinalActionValue" />
      <span class="flex-1"></span>
      <i @click="removeItem" class="icon remove ti ti-square-rounded-minus"></i>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    //
  },
  computed: {
    store() {
      return this.config?.store
    },
    storeId() {
      return this.config?.storeId
    },
    event() {
      return this.config?.event ?? null
    },
    action() {
      return this.config?.action || {}
    },
    more() {
      return this.config?.more || {}
    },
    packages() {
      return this.more?.action_packages || {}
    },
    collections() {
      return this.more?.collections || {}
    },
    packageOptions() {
      return (this.more.events?.[this.event]?.actions || []).reduce((result, current) => {
        result.push({
          id: current,
          text: this.packages?.[current]?.label
        })
        return result
      }, [])
    },
    finalActionPackage() {
      let packageName = null
      if (Object.keys(this.packages).includes(this.action.package)) {
        packageName = _.pascalCase(this.action.package)
      }
      return packageName ? `ActionPackage${packageName}` : null
    },
    finalActionValue() {
      let packageName
      if (Object.keys(this.collections).includes(this.action.collection)) {
        packageName = _.pascalCase(this.action.collection)
      }
      return packageName ? `ActionValue${packageName}` : null
    }
  },
  methods: {
    removeItem() {
      const lastIndex = this.storeId.lastIndexOf('.')
      const baseStoreId = this.storeId.substring(0, lastIndex)
      const index = this.storeId.substring(lastIndex + 1)
      let actions = this.store.getter(baseStoreId, [])
      actions.splice(index, 1)
      this.store.commit(baseStoreId, actions)
    },
    changeFinalActionPackage({ field, value }) {
      this.store.commit(`${this.storeId}.${field}`, value)
    },
    changeFinalActionValue(value) {
      this.store.commit(`${this.storeId}.value`, value)
    }
  },
  watch: {
    // 'action.package'(name) {
    //   this.store.commit(this.storeId, {
    //     package: name
    //   })
    // },
    finalActionPackage: {
      handler(name) {
        if (this.$options.components?.[name] || !name) return
        const path = `/views/Automation/Modal/Actions/Packages`
        this.$options.components[name] = this.$util.requireOrNull(`${path}/${name.replace(/^ActionPackage/g, '')}Package.vue`) || this.$util.requireOrNull(`${path}/DefaultPackage.vue`)
      },
      immediate: true
    },
    finalActionValue: {
      handler(name) {
        if (this.$options.components?.[name] || !name) return
        const path = `/views/Automation/Modal/Actions/Values`
        this.$options.components[name] = this.$util.requireOrNull(`${path}/${name.replace(/^ActionValue/g, '')}Value.vue`) || this.$util.requireOrNull(`${path}/DefaultValue.vue`)
      },
      immediate: true
    }
  },
  props: {
    config: Object
  }
}
</script>
